/**
 * 接口域名的管理
 */
const base = {
  // sq: 'https://xxxx111111.com/api/v1',
  bd: "/api"
};

export default base;
